import React from 'react';
import { Form } from 'antd';

import './withValidation.css';

const FormItem = Form.Item;

const withValidation = (Field, props, config) => {
  let { decorator } = props;
  const filteredProps = Object.fromEntries(
    Object.entries(props).filter(item => item[0] !== 'decorator')
  );

  return (
    <FormItem label={config.label} className={`formItem ${props.classes}`}>
      {decorator(config.name, {
        initialValue: config.value,
        rules: config.rules,
      })(
        <Field className={props.classes} {...filteredProps}>
          {props.children}
        </Field>
      )}
    </FormItem>
  );
};

export default withValidation;
